import { useQuery } from "@apollo/client/react";
import { INVENTORY_REQUESTS_QUERY } from "../../../../../constants/graphql/queries";

export default function useInventoryRequestData(type, itemId) {
  const { data, loading, error } = useQuery(INVENTORY_REQUESTS_QUERY, {
    variables: {
      type,
      search: itemId || "",
    },
    skip: !itemId,
  });

  const inventoryRequests = data?.inventoryRequests?.collection || [];

  const getQuantityText = asset => {
    if (inventoryRequests.length === 0) {
      return "";
    }

    const items = inventoryRequests.map(request => {
      const totalQuantity =
        request.inventoryItems
          ?.filter(item => item.asset?.itemId === asset?.itemId)
          ?.reduce((sum, item) => sum + (item.quantity || 0), 0) || 0;

      return `${request.workOrderNumber} (${totalQuantity})`;
    });

    return items.join(", ");
  };

  return {
    inventoryRequests,
    loading,
    error,
    getQuantityText,
  };
}
